module.exports = __webpack_public_path__ + "static/media/AppBirthday.49972a1a.png";